window.App.forms = {};
require("./form");
require("./errors");
window.$.extend(window.App, require("./http").default);
